import { makeObservable } from "mobx";
import { BaseSyncModel } from "@/store/sync/BaseSyncModel";
import { SyncModelKind } from "@/store/sync/types";
import { WithAppStore } from "@/store/types";
import { NoteSourceModelData } from "./types";
import { SyncUpdateValue } from "@/store/sync/types";

export class NoteSourceObservable extends BaseSyncModel<NoteSourceModelData> {
  public modelKind = SyncModelKind.NoteSource;

  constructor({
    id,
    data,
    store,
  }: { id: string; data: SyncUpdateValue<NoteSourceModelData> } & WithAppStore) {
    super({ id, data, store });

    makeObservable(this, {
      modelKind: false,
    });
  }
}
